/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewWorkflowEvent } from '../models/new-workflow-event';
import { WorkflowEvent } from '../models/workflow-event';
import { WorkflowEventPartial } from '../models/workflow-event-partial';
import { WorkflowEventWithRelations } from '../models/workflow-event-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class WorkflowEventControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation workflowEventControllerCount
   */
  static readonly WorkflowEventControllerCountPath = '/workflow-events/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowEventControllerService.WorkflowEventControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation workflowEventControllerFindStarterEvents
   */
  static readonly WorkflowEventControllerFindStarterEventsPath = '/workflow-events/starter-events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStarterEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  findStarterEvents$Response(params?: {
  }): Observable<StrictHttpResponse<Array<WorkflowEvent>>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowEventControllerService.WorkflowEventControllerFindStarterEventsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkflowEvent>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findStarterEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findStarterEvents(params?: {
  }): Observable<Array<WorkflowEvent>> {

    return this.findStarterEvents$Response(params).pipe(
      map((r: StrictHttpResponse<Array<WorkflowEvent>>) => r.body as Array<WorkflowEvent>)
    );
  }

  /**
   * Path part for operation workflowEventControllerFindStarterTemplateEvents
   */
  static readonly WorkflowEventControllerFindStarterTemplateEventsPath = '/workflow-events/starter-template-events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStarterTemplateEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  findStarterTemplateEvents$Response(params?: {
  }): Observable<StrictHttpResponse<Array<WorkflowEvent>>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowEventControllerService.WorkflowEventControllerFindStarterTemplateEventsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkflowEvent>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findStarterTemplateEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findStarterTemplateEvents(params?: {
  }): Observable<Array<WorkflowEvent>> {

    return this.findStarterTemplateEvents$Response(params).pipe(
      map((r: StrictHttpResponse<Array<WorkflowEvent>>) => r.body as Array<WorkflowEvent>)
    );
  }

  /**
   * Path part for operation workflowEventControllerUpsertRequiredModelsAsMetadata
   */
  static readonly WorkflowEventControllerUpsertRequiredModelsAsMetadataPath = '/workflow-events/{id}/upsert-required-models-as-metadata';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertRequiredModelsAsMetadata()` instead.
   *
   * This method doesn't expect any request body.
   */
  upsertRequiredModelsAsMetadata$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowEventControllerService.WorkflowEventControllerUpsertRequiredModelsAsMetadataPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `upsertRequiredModelsAsMetadata$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  upsertRequiredModelsAsMetadata(params: {
    id: string;
  }): Observable<any> {

    return this.upsertRequiredModelsAsMetadata$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowEventControllerFindById
   */
  static readonly WorkflowEventControllerFindByIdPath = '/workflow-events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<WorkflowEvent>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowEventControllerService.WorkflowEventControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkflowEvent>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<WorkflowEvent> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<WorkflowEvent>) => r.body as WorkflowEvent)
    );
  }

  /**
   * Path part for operation workflowEventControllerDeleteById
   */
  static readonly WorkflowEventControllerDeleteByIdPath = '/workflow-events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowEventControllerService.WorkflowEventControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowEventControllerUpdateById
   */
  static readonly WorkflowEventControllerUpdateByIdPath = '/workflow-events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: WorkflowEventPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowEventControllerService.WorkflowEventControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: WorkflowEventPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowEventControllerFind
   */
  static readonly WorkflowEventControllerFindPath = '/workflow-events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<WorkflowEventWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowEventControllerService.WorkflowEventControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkflowEventWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<WorkflowEventWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<WorkflowEventWithRelations>>) => r.body as Array<WorkflowEventWithRelations>)
    );
  }

  /**
   * Path part for operation workflowEventControllerCreate
   */
  static readonly WorkflowEventControllerCreatePath = '/workflow-events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewWorkflowEvent
  }): Observable<StrictHttpResponse<WorkflowEvent>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowEventControllerService.WorkflowEventControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkflowEvent>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewWorkflowEvent
  }): Observable<WorkflowEvent> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<WorkflowEvent>) => r.body as WorkflowEvent)
    );
  }

}
